/**
 * AddUsersReportsCtrl controller
 * Add/Edit Users Report
 */

import moment from 'moment'
import { PAYMENT_SYSTEM_TYPES, SUBSCRIPTION_PLANS_TYPE } from 'app/core/constants'
import { ascBy, has, lowerCaseProperty } from 'app/helpers/object'

/**
 * AddUsersReportsCtrl controller
 *
 * @class AddUsersReportsCtrl
 * @memberof mwApp/addUsersReportsCtrl
 * @see mwApp/addUsersReportsCtrl
 *
 * @ngdoc controller
 * @name mwApp/addUsersReportsCtrl.controller:AddUsersReportsCtrl
 */
/* @ngInject */
export default function AddUsersReportsCtrl ($scope, $location, ReportUsersSeed, commonData) {
  var vm = this

  vm.reportDates = {
    today: 'Today',
    yesterday: 'Yesterday',
    '3Days': '3Days',
    '1Week': '1 Week',
    '2Week': '2 Weeks',
    month: 'Month',
    '3Months': '3 Months',
    '6Months': '6 Months',
    year: '1 Year',
    custom: 'Custom'
  }
  /**
   * Listen tab event
   */ // TODO: may be will delete
  $scope.$on('dispatch: users_reports', function () {
    $scope.$broadcast('refreshTable')
  })

  // change reportPeriod list
  $scope.$watch('vm.reportPeriod', (type) => {
    vm.selectReportPeriod(type)
  })

  // reset users if changed packages
  $scope.$watch('vm.report.networks', () => {
    vm.report.users = []
    vm.report.subscriptions = []
  })

  /**
   * Payment types
   *
   * @memberof mwApp/packages.controller:AddSubscribersReportCtrl
   * @type {Object}
   */
  vm.payment_system_types = PAYMENT_SYSTEM_TYPES

  /**
   * Payment types
   *
   * @memberof mwApp/packages.controller:AddSubscribersReportCtrl
   * @type {Object}
   */
  vm.subscription_plans_type = SUBSCRIPTION_PLANS_TYPE

  /**
   * Report state model
   *
   * @memberof mwApp/reports.controller:AddSubscribersReportCtrl
   * @type {Object}
   */
  vm.report = new ReportUsersSeed()

  /**
   * Report types url list
   *
   * @type {Object}
   */
  vm.users_reporting_url = {
    ACTIVATIONS: 'activations'
  }

  /**
   * Report reportPeriod default value
   *
   * @memberof mwApp/reports.controller:AddSubscribersReportCtrl
   * @type {String}
   */
  vm.reportPeriod = 'yesterday'

  /**
   * Is Custom period default value
   *
   * @memberof mwApp/reports.controller:AddSubscribersReportCtrl
   * @type {Boolean}
   */
  vm.isCustomPeriod = false

  /**
   * Search users params with default values
   *
   * @memberof mwApp/reports.controller:AddSubscribersReportCtrl
   * @type {Object}
   */
  vm.searchUsersParams = {
    searchStr: '',
    networkIds: [],
    page: 0,
    totalPages: 0
  }

  /**
   * Search users params with default values
   *
   * @memberof mwApp/reports.controller:AddSubscribersReportCtrl
   * @type {Object}
   */
  vm.searchSubscriptionsParams = {
    searchStr: '',
    networkIds: [],
    page: 0,
    totalPages: 0
  }

  /**
   * Load extra data packages
   */
  ReportUsersSeed.load(`api/reports/users/${vm.users_reporting_url.ACTIVATIONS}/extra/networks`, {
    networks: []
  }).to(vm.packages = []).then(() => {
    vm.packages.sort(ascBy(lowerCaseProperty('name')))
    vm.packages = [{ id: null, name: 'All Organizations' }].concat(vm.packages)
  })

  /**
   * Load extra data payment types
   */
  ReportUsersSeed.load(`api/reports/users/${vm.users_reporting_url.ACTIVATIONS}/extra/paymenttypes`, {
    paymentSystemTypes: []
  })
    .to(vm.paymentSystemTypes = [])
    .then(() => {
      vm.paymentSystemTypes = vm.paymentSystemTypes.filter(p => !['NEWEBPAY', 'TELR'].includes(p))
    })

  /**
   * Load extra data users
   */
  ReportUsersSeed.search(
    `api/reports/users/${vm.users_reporting_url.ACTIVATIONS}/extra/users`,
    vm.searchUsersParams
  )
    .then((result) => {
      vm.searchUsersParams.totalPages = result.totalPages
      return result.content || []
    })
    .to(vm.users = [])

  /**
   * Load extra data users
   */
  ReportUsersSeed.search(
    `api/reports/users/${vm.users_reporting_url.ACTIVATIONS}/extra/subscriptions`,
    vm.searchSubscriptionsParams
  )
    .then((result) => {
      vm.searchSubscriptionsParams.totalPages = result.totalPages
      return result.content || []
    })
    .to(vm.subscriptionPlans = [])
    .then(() => {
      vm.subscriptionPlans.unshift({
        id: null,
        key: 'CUSTOM_PLANS',
        name: 'Custom Plans'
      })
    })

  /**
   * Select interval by Report Date
   *
   * @param {String} reportPeriodType
   */
  vm.selectReportPeriod = (reportPeriodType) => {
    let from = new Date()
    let to = new Date()
    let periodAmount = 1
    let periodType = 'DAYS'

    switch (reportPeriodType) {
      case 'custom':
      case 'today':
        periodAmount = 0
        from = moment().toDate()
        break
      case 'yesterday':
        from = moment().subtract(periodAmount, 'day').toDate()
        to = moment().subtract(1, 'day').toDate()
        break
      case '3Days':
        periodAmount = 3
        from = moment().subtract(periodAmount, 'day').toDate()
        break
      case '1Week':
        periodAmount = 7
        periodType = 'DAYS'
        from = moment().subtract(periodAmount, 'day').toDate()
        break
      case '2Week':
        periodAmount = 14
        periodType = 'DAYS'
        from = moment().subtract(periodAmount, 'day').toDate()
        break
      case 'month':
        periodType = 'MONTHS'
        from = moment().subtract(1, 'months').toDate()
        break
      case '3Months':
        periodAmount = 3
        periodType = 'MONTHS'
        from = moment().subtract(3, 'months').toDate()
        break
      case '6Months':
        periodAmount = 6
        periodType = 'MONTHS'
        from = moment().subtract(6, 'months').toDate()
        break
      case 'year':
        periodType = 'YEARS'
        from = moment().subtract(1, 'year').toDate()
        break
    }

    vm.report.periodAmount = periodAmount
    vm.report.periodType = periodType
    vm.isCustomPeriod = reportPeriodType === 'custom'
    vm.report.from = from
    vm.report.to = to
  }

  // cache default handler for datepicker
  const changeHandlerFrom = () => {
    let fromActual = new Date(vm.report.from)
    let toActual = new Date(vm.report.to)

    if (fromActual.setHours(0, 0, 0, 0) > toActual.setHours(0, 0, 0, 0)) {
      vm.report.from = new Date(toActual.setDate(toActual.getDate() - 1))

      fromActual = angular.copy(vm.report.from)
      toActual = angular.copy(vm.report.to)
    }

    vm.dpCfgFrom.maxDate = new Date(toActual.setDate(toActual.getDate()))
    vm.dpCfgTo.minDate = new Date(fromActual.setDate(fromActual.getDate()))
  }

  /**
   * Datepicker default settings
   *
   * @memberof mwApp/reports.controller:AddUsersReportCtrl
   * @type {{format : string}}
   */
  vm.dpCfgFrom = {
    format: 'dd.MM.yyyy',
    minDate: moment().subtract(1, 'day').endOf('day').subtract(1, 'year').add(1, 'seconds').toDate(),
    maxDate: moment().toDate(),
    changeHandler: changeHandlerFrom
  }

  /**
   * Handle open "from" datepicker
   *
   * @memberof mwApp/reports.controller:AddUsersReportCtrl
   */
  vm.openFrom = function () {
    vm.dpCfgFrom.openedFrom = true
  }

  // cache default handler for datepicker
  const changeHandlerTo = () => {
    let fromActual = new Date(vm.report.from)
    let toActual = new Date(vm.report.to)

    if (fromActual.setHours(0, 0, 0, 0) > toActual.setHours(0, 0, 0, 0)) {
      vm.report.to = new Date(fromActual.setDate(fromActual.getDate() + 1))

      fromActual = angular.copy(vm.report.from)
      toActual = angular.copy(vm.report.to)
    }

    vm.dpCfgFrom.maxDate = new Date(toActual.setDate(toActual.getDate()))
    vm.dpCfgTo.minDate = new Date(fromActual.setDate(fromActual.getDate()))
  }

  /**
   * Datepicker default settings
   *
   * @memberof mwApp/reports.controller:AddUsersReportCtrl
   * @type {{format : string}}
   */
  vm.dpCfgTo = {
    format: 'dd.MM.yyyy',
    minDate: moment().toDate(),
    // maxDate: moment(vm.report.to).toDate(),
    changeHandler: changeHandlerTo
  }

  /**
   * Handle open "to" datepicker
   *
   * @memberof mwApp/reports.controller:AddUsersReportCtrl
   */
  vm.openTo = function () {
    vm.dpCfgTo.openedTo = true
  }

  /**
   * Generate report
   *
   * @memberof mwApp/reports.controller:AddUsersReportCtrl
   */
  vm.generateReport = function () {
    vm.setDisable()
    vm.report
      ._save(null, 'api/reports/users/' + vm.users_reporting_url.ACTIVATIONS)
      .data()
      .then(function (response) {
        const id = response.payload.id
        $location.hash('generated_reports')

        commonData.data.update('lastReport', id)

        vm.location.reload()
      })
      .finally(vm.unsetDisable)
  }

  /**
   * Save reports
   *
   * @memberof mwApp/reports.controller:AddUsersReportCtrl
   */
  vm.submit = function () {
    vm.setDisable()
    vm.report
      ._save(() => {}, `api/reports/users/${vm.users_reporting_url.ACTIVATIONS}/templates`)
      .then(function (response) {
        $location.hash('reports_list')

        commonData.data.update('lastTemplate', has('payload')(response.data)
          ? response.data.payload.id
          : response.data.id)

        vm.location.reload()
      })
      .finally(vm.unsetDisable)
  }

  /**
   * Change Subscription Plans
   */
  vm.changeSubscription = function () {
    vm.report.subscriptions = []
    vm.report.subscriptionFromDays = null
    vm.report.subscriptionToDays = null
    vm.report.subscriptionFromMonth = null
    vm.report.subscriptionToMonth = null
    vm.report.availableAllSubscriptions = true
    vm.report.includeCustomSubscriptions = false
  }

  /**
   * Filter users, it seems that this works faster, then filter in ui-select-choices
   *
   * @memberof mwApp/shows.controller:AddUsersReportCtrl
   * @param  {Object} $select
   */
  vm.$timerUsers = 0
  vm.openCountUsers = 0
  vm.refreshUsers = function ($select = {}) {
    let search = $select.search || ''

    vm.searchUsersParams.page = 0

    search = search ? search.toLowerCase() : ''
    vm.openCountUsers = $select.open ? vm.openCountUsers + 1 : 0

    if (vm.openCountUsers > 1) {
      vm.searchUsersParams.searchStr = $select.search
    }

    if (vm.openCountUsers === 1) {
      $select.search = vm.searchUsersParams.searchStr
    }

    if ($select.open) {
      window.clearTimeout(vm.$timerUsers)
      vm.$timerUsers = window.setTimeout(() => {
        ReportUsersSeed.search(
          `api/reports/users/${vm.users_reporting_url.ACTIVATIONS}/extra/users`,
          {
            searchStr: search,
            page: 0,
            networkIds: vm.report.networks.map((n) => n.id).filter(n => n !== null)
          }
        )
          .then((result) => {
            vm.searchUsersParams.totalPages = result.totalPages
            vm.users = result.content || []
          })
      }, 700)
    }
  }

  /**
   * Tag transformer for custom select value
   *
   * @param newTag
   * @return {{id : null, email : *}}
   */
  vm.tagTransform = function (newTag) {
    return {
      id: null,
      email: newTag
    }
  }

  /**
   * Filter subscriptions, it seems that this works faster, then filter in ui-select-choices
   *
   * @memberof mwApp/shows.controller:AddUsersReportCtrl
   * @param  {Object} $select
   */
  vm.$timerSubscriptions = 0
  vm.openCountSubscriptions = 0
  vm.refreshSubscriptions = function ($select = {}) {
    let search = $select.search || ''

    vm.searchSubscriptionsParams.page = 0

    search = search ? search.toLowerCase() : ''
    vm.openCountSubscriptions = $select.open
      ? vm.openCountSubscriptions + 1
      : 0

    if (vm.openCountSubscriptions > 1) {
      vm.searchSubscriptionsParams.searchStr = $select.search
    }

    if (vm.openCountSubscriptions === 1) {
      $select.search = vm.searchSubscriptionsParams.searchStr
    }

    if ($select.open) {
      window.clearTimeout(vm.$timerSubscriptions)
      vm.$timerSubscriptions = window.setTimeout(() => {
        ReportUsersSeed.search(
          `api/reports/users/${vm.users_reporting_url.ACTIVATIONS}/extra/subscriptions`,
          {
            searchStr: search,
            page: 0,
            networkIds: vm.report.networks.map((n) => n.id)
          }
        )
          .then((result) => {
            vm.searchSubscriptionsParams.totalPages = result.totalPages
            vm.subscriptionPlans = result.content || []
            vm.subscriptionPlans.unshift({
              id: null,
              key: 'CUSTOM_PLANS',
              name: 'Custom Plans'
            })
          })
      }, 700)
    }
  }

  /**
   * Callback for Select subscriptions item
   *
   */
  vm.onSelectedSubscription = function () {
    vm.report.includeCustomSubscriptions = !!vm.report.subscriptions.find((s) => !s.id)
  }

  /**
   * Callback for remove subscriptions item
   */
  vm.onRemoveSubscription = function () {
    vm.report.includeCustomSubscriptions = !!vm.report.subscriptions.find((s) => !s.id)
    if (!vm.report.subscriptions.length) {
      vm.report.includeCustomSubscriptions = true
    }
  }

  /**
   * Handler for scroll event of select list
   *
   * @param event
   */
  vm.$timerUsersScroll = 0
  vm.usersCallbackScroll = (event) => {
    const { page, totalPages } = vm.searchUsersParams
    if (page <= totalPages && event.currentTarget.scrollTop >= (event.currentTarget.scrollHeight - event.currentTarget.clientHeight) * 0.6) {
      window.clearTimeout(vm.$timerUsersScroll)
      vm.$timerUsersScroll = window.setTimeout(() => {
        ReportUsersSeed.search(
          `api/reports/users/${vm.users_reporting_url.ACTIVATIONS}/extra/users`,
          { ...vm.searchUsersParams, page: page + 1 }
        )
          .then((result) => {
            vm.users = vm.users.concat(result.content)
            vm.searchUsersParams.page = result.number
          })
      }, 700)
    }
  }

  /**
   * Handler for scroll event of select list
   *
   * @param event
   */
  vm.$timerSubscriptionsScroll = 0
  vm.subscriptionsCallbackScroll = (event) => {
    const { page, totalPages } = vm.searchSubscriptionsParams
    if (page <= totalPages && event.currentTarget.scrollTop >= (event.currentTarget.scrollHeight - event.currentTarget.clientHeight) * 0.6) {
      window.clearTimeout(vm.$timerSubscriptionsScroll)
      vm.$timerSubscriptionsScroll = window.setTimeout(() => {
        ReportUsersSeed.search(
          `api/reports/users/${vm.users_reporting_url.ACTIVATIONS}/extra/subscriptions`,
          { ...vm.searchSubscriptionsParams, page: page + 1 }
        )
          .then((result) => {
            vm.subscriptionPlans = vm.subscriptionPlans.concat(result.content)
            vm.searchSubscriptionsParams.page = result.number
          })
      }, 700)
    }
  }

  $scope.$watch('vm.report.networks', () => {
    if (vm.report.networks.length > 1 && vm.report.networks.find(n => n.id === null)) {
      vm.report.networks = vm.report.networks.filter(n => n.id === null)
    }
  })
}
